module.exports = __webpack_public_path__ + "img/facebook.b315909e.svg";